import { Routes } from '@angular/router';
import { BlankComponent } from './presentation/layouts/blank/blank.component';
import { FullComponent } from './presentation/layouts/full/full.component';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: 'session',
    component: BlankComponent,
    canMatch: [NoAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./presentation/pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: 'landingpage',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./presentation/pages/theme-pages/landingpage/landingpage.routes').then(
            (m) => m.LandingPageRoutes
          ),
      },
    ],
  },
  {
    path: 'front-pages',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./presentation/pages/front-pages/front-pages.routes').then(
          (m) => m.FrontPagesRoutes)
      },
    ],
  },
  {
    path: '',
    component: FullComponent,
    canMatch: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./presentation/pages/dashboard-erp/dashboard-erp.component').then(
            (m) => m.DashboardErpComponent
          ),
        data: { title: 'Tablero comercial' },
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./presentation/pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./presentation/pages/dashboards/dashboards.routes').then(
            (m) => m.DashboardsRoutes
          ),
      },

      {
        path: 'forms',
        loadChildren: () =>
          import('./presentation/pages/forms/forms.routes').then((m) => m.FormsRoutes),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./presentation/pages/charts/charts.routes').then((m) => m.ChartsRoutes),
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./presentation/pages/apps/apps.routes').then((m) => m.AppsRoutes),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./presentation/pages/widgets/widgets.routes').then((m) => m.WidgetsRoutes),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./presentation/pages/tables/tables.routes').then((m) => m.TablesRoutes),
      },
      {
        path: 'datatable',
        loadChildren: () =>
          import('./presentation/pages/datatable/datatable.routes').then(
            (m) => m.DatatablesRoutes
          ),
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./presentation/pages/theme-pages/theme-pages.routes').then(
            (m) => m.ThemePagesRoutes
          ),
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./presentation/pages/ui-components/ui-components.routes').then(
            (m) => m.UiComponentsRoutes
          ),
      },
      {
        path: 'obras',
        loadChildren: () =>
          import('./presentation/pages/obras/obras.routes').then(
            (m) => m.ObrasRoutes
          ),
      },
      {
        path: 'agrupadores',
        loadChildren: () =>
          import('./presentation/pages/agrupadores/agrupadores.routes').then(
            (m) => m.AgrupadoresRoutes
          ),
      },
      {
        path: 'conceptos',
        loadChildren: () =>
          import('./presentation/pages/conceptos/conceptos.routes').then(
            (m) => m.ConceptosRoutes
          ),
      },
      {
        path: 'transporte',
        loadChildren: () =>
          import('./presentation/pages/transporte/transporte.routes').then(
            (m) => m.TransporteRoutes
          ),
      },
      {
        path: 'punto-venta',
        loadChildren: () =>
          import('./presentation/pages/punto-venta/punto-venta.routes').then(
            (m) => m.PuntoVentaRoutes
          ),
      },
      {
        path: 'catalogos',
        loadChildren: () =>
          import('./presentation/pages/catalogos/catalogos.routes').then(
            (m) => m.CatalogosRoutes
          ),
      },
      {
        path: 'suministros',
        loadChildren: () =>
          import('./presentation/pages/suministros/suministros.routes').then(
            (m) => m.SuministrosRoutes
          ),
      },
      {
        path: 'ventas',
        loadChildren: () =>
          import('./presentation/pages/ventas/ventas.routes').then(
            (m) => m.VentasRoutes
          ),
      },
      {
        path: 'inventario',
        loadChildren: () =>
          import('./presentation/pages/inventario/inventario.routes').then(
            (m) => m.InventarioRoutes
          ),
      },
      {
        path: 'finanzas',
        loadChildren: () =>
          import('./presentation/pages/finanzas/finanzas.routes').then(
            (m) => m.FinanzasRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
